Vue.component('map-item', {
	props: ["currentnodo","options"],
	template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutDown" v-bind:css="options.internal.isAnimationCompatibility">' +
		'<div id="map-item"><img :src="mapSrc"></div>' +
		'</transition>',
	data: function () {
		return {
			mapSrc:null,
			isActive:false,
			apiKeyStaticMap:"AIzaSyA9jXTnsY3AOuqY87vbdxAyydK_zRbEoxE",
			currentLat:null,
			currentLng:null,
			urlStaticMap: "https://maps.googleapis.com/maps/api/staticmap?"
		}
	},
	created: function () {
		this.initMap();
	},
	methods: {
		buildStaticMap:function(){
		},
		initMap: function () {
			this.isActive = true;
			var mapPosition = this.currentnodo.msg.text;
			mapPosition = mapPosition.replace(/Lat:|Long:/gi, '');
			mapPosition = mapPosition.replace(/&/i, ',');
			this.mapSrc = this.urlStaticMap+"size=300x200&markers=color:red%7Clabel:S%7C"+mapPosition+"&center="+mapPosition+"&zoom=14&&key="+this.apiKeyStaticMap
		}
	}
})